import CustomSelect from "./CustomSelect";

export default CustomSelect;



// WEBPACK FOOTER //
// ./src/commonComponents/CustomSelect/index.js